<script>
	import { getContext, onMount } from 'svelte';

	import { keyToken } from '../../globals.js';
	import { formatAmount, formatCardinal } from '../formatting.js';
	import SortableTable from '../table/SortableTable.svelte';
	import StockTableCell from '../table/StockTableCell.svelte';

	const { getToken } = getContext(keyToken);
	const token = getToken();

	let isin;

	let stocks = [];
	let title = '';
	let totalQuantity;
	let totalAmount;

	export let showHistoric;

	async function loadPortfolioDetails() {
		if (!token) {
			console.warn('Not logged in!');
			return;
		}

		await fetch('https://ostium.ch/api/borsalino/get_portfolio_details.php', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8',
				'Authorization': 'JWT ' + encodeURIComponent(token)
			},
			body: JSON.stringify({ isin: isin, historic: showHistoric })
		}).then(result => {
			if (result.ok) {
				console.log('Loaded portfolio details successfully.');
				result.json().then(data => {
					console.log('Portfolio details:', data);
					totalQuantity = 0;
					totalAmount = 0;
					stocks = data.map(stock => {
						stock.date = stock.value_date != null ? new Date(stock.value_date) : null;
						stock.amount = (stock.dividend ? -1 : 1) * stock.amount;
						stock.comment = stock.comment != null && stock.comment.length > 0 ? stock.comment : stock.dividend ? 'Dividend' : '';
						title = stock.name;
						totalQuantity += stock.dividend ? 0 : stock.quantity;
						totalAmount += stock.amount / stock.factor;
						return stock;
					});
				});
			} else {
				console.warn('Could not load portfolio details.', result.statusText);
			}
		});
	}

	onMount(() => {
		jQuery('#purchaseDetailsDialog').on('show.bs.modal', function (event) {
			let target =  event.relatedTarget;
			if (target != null && target.dataset != null && target.dataset['isin'] != null) {
				isin = target.dataset['isin'];
				loadPortfolioDetails();
			}
		});
	});
</script>

<div class="modal fade" id="purchaseDetailsDialog" tabindex="-1" role="dialog">
	<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
		<div class="modal-content bg-dark">
			<div class="modal-header">
				<h5 class="modal-title">Details {title}</h5>
				<button type="button" class="close text-light" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<SortableTable class="table table-sm table-dark table-striped" headClass="bg-secondary" footClass="bg-secondary" items={stocks}>
					<tr slot="thead">
						<th data-sort="date" data-sort-initial="descending">Date</th>
						<th class="text-right" data-sort="quantity">Quantity</th>
						<th class="text-right" data-sort="price">Price</th>
						<th class="text-right" data-sort="fee">Fee</th>
						<th class="text-right" data-sort="tax">Tax</th>
						<th class="text-right" data-sort="amount">Amount</th>
						<th data-sort="comment">Comment</th>
					</tr>
					<tr slot="tbody" let:item={stock}>
						<StockTableCell {stock} show='date'/>
						<td class="text-right">{stock.quantity}</td>
						<StockTableCell {stock} show='price'/>
						<StockTableCell {stock} show='fee'/>
						<StockTableCell {stock} show='tax'/>
						<StockTableCell {stock} show='amount'/>
						<StockTableCell {stock} show='comment'/>
					</tr>
					<tr slot="tfoot">
						<th>Total</th>
						<th class="text-right">{formatCardinal(totalQuantity)}</th>
						<th></th>
						<th></th>
						<th></th>
						<th class="text-right">{formatAmount(totalAmount)}</th>
						<th></th>
					</tr>
				</SortableTable>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
			</div>
		</div>
	</div>
</div>
